import { Button, FoodsIcon, FoodsIconButton, useFormBaseContext } from "@foodpilot/foods";
import CreateOutlined from "@mui/icons-material/CreateOutlined";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useResponsiveBreakpoints } from "src/utils/useResponsiveBreakpoints";
import type { SupplierFormAppearance } from "../../SupplierForm.types";

type ModifyButtonProps = {
    appearance?: SupplierFormAppearance;
    pageNumber: number;
};
export const ModifyButton = (props: ModifyButtonProps) => {
    const { setPage } = useFormBaseContext();
    const { t } = useTranslation();
    const { isExtraSmall } = useResponsiveBreakpoints();
    const theme = useTheme();

    const modifyText = t("modifier");

    if (props.appearance !== "product-v2") {
        return (
            <Button
                variant="white-filled"
                startIcon={<CreateOutlined />}
                sx={{ marginRight: theme.spacing(3), borderRadius: theme.spacing(5.5) }}
                onClick={() => setPage(props.pageNumber)}
            >
                {modifyText}
            </Button>
        );
    }

    if (isExtraSmall) {
        return (
            <FoodsIconButton
                icon="edit"
                size="m"
                buttonProps={{
                    "aria-label": modifyText,
                    onClick: () => setPage(props.pageNumber),
                    type: "button",
                }}
                tooltip={{ text: modifyText }}
            />
        );
    }

    return (
        <Button
            variant="white-filled"
            startIcon={<FoodsIcon icon="edit" size={2} />}
            onClick={() => setPage(props.pageNumber)}
        >
            {modifyText}
        </Button>
    );
};
